export const PROMPT_TEXT = 'prompText';
export const PROMPT_RESULT = 'promptResult';

export const getSwitchOptions = (isMediaPrompt: boolean) => [
    { label: isMediaPrompt ? 'Фото' : 'Промпт', value: PROMPT_TEXT },
    { label: isMediaPrompt ? 'Видео' : 'Результат', value: PROMPT_RESULT },
];

export const getGuideText = (isPromptOption: boolean) => {
    return isPromptOption
        ? 'В чате с Алисой замените данные в скобках <mark>[...]</mark> на свои'
        : 'Один из возможных результатов';
};
